const isBDActive = () => {
    const getValidDate = date => new Date(date)
    const currentDate = '2026-10-30T14:55';
    const startDate = '2025-10-08T00:00';
    let endDate = '2025-10-08';
    if ('' !== endDate) {
        endDate = '2025-10-08T23:59' 
    }

    return getValidDate(startDate) <= getValidDate(currentDate) && getValidDate(currentDate) <= getValidDate(endDate)
}

window.biotech_day_is_active = isBDActive()